import { FunctionComponent, memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Story } from '../../../services';
import { CardOpenButton, StoryTabType } from '../../../shared';
import { StoryFollowStatus } from './StoryFollowStatus';

import classes from './StoryList.module.scss';

interface StoryListProps {
  stories: Story[];
  storyTabType: StoryTabType;
}

export const StoryList: FunctionComponent<StoryListProps> = memo(({ stories, storyTabType }) => {
  const navigate = useNavigate();

  return (
    <div className={classes['story-list']}>
      {stories.map((story) => {
        const { id, title, subtitle, image } = story;

        const { url: imageUrl } = { ...image };

        return (
          <div
            key={id}
            className={classes['story-list__item']}
            onClick={() => navigate(`/${storyTabType}/${id}/items`)}
          >
            <CardOpenButton label={title} />

            <div className={classes['story-list__item-description']}>
              <StoryFollowStatus story={story} />
              <div className={classes['story-list__item-title']}>{title}</div>
              {subtitle && <div className={classes['story-list__item-subTitle']}>{subtitle}</div>}
            </div>
            {imageUrl && (
              <div className={classes['story-list__item-image-wrapper']}>
                <img className={classes['story-list__item-image']} src={imageUrl} alt={''} />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
});
